enum SSO {
  InvalidCode               = "PBSSOInvalidCode",
  UserWithEmailHasSsoId     = "PBSSOUserWithEmailHasSsoId",
  UserWithEmailDoesNotExist = "PBSSOUserWithEmailDoesNotExist",
  UnexpectedError           = "PBSSOUnexpectedError"
}

export default SSO
